import { useEffect, useMemo, useState } from 'react'
import { useUserContext } from '@vp/ubik-context'

import { history as galleryHistory } from '~/app/utils/history'
import { transformQueryStrings } from '~/shared/url'

export const useSearchParams = (): URLSearchParams => {
  const { queryStrings } = useUserContext()

  const serverQuery = transformQueryStrings(queryStrings)
  const [clientQuery, setClientQuery] = useState<string | undefined>()

  useEffect(() => {
    setClientQuery(galleryHistory?.location?.search)
  }, [])

  return useMemo(() => new URLSearchParams(clientQuery ?? serverQuery), [clientQuery, serverQuery])
}
